import type { PlatformComponentProps } from "@b2bportal/core-types";
import { TRIPS_PATH } from "@overrides/utilities";
import { ActivityReservationPage } from "@tenant/activities";
import {
  useActivityReservationPageContainer,
  useActivityReservationPageRoute,
} from "./hooks";

export const ActivityReservationPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useActivityReservationPageRoute();
  const data = useActivityReservationPageContainer({
    reservationId: params.reservationId,
    tripsRoute: TRIPS_PATH,
  });

  return (
    <ActivityReservationPage {...data} className={className}>
      {children}
    </ActivityReservationPage>
  );
};
